/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgHifiIcon } from "../shared/SvgHifiIcon";
var EmailHifiIcon = function EmailHifiIcon(props) {
  return /*#__PURE__*/React.createElement(SvgHifiIcon, props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 34.6354L18.2069 22.3718L5 12.2595V34.6354ZM19.8041 23.5948C19.7679 23.6436 19.7267 23.6899 19.6805 23.7328L6.46961 36H41.5304L28.3196 23.7328C28.2734 23.6899 28.2321 23.6436 28.1959 23.5948L25.9456 25.3178C25.3934 25.7593 24.7073 26 24 26C23.2927 26 22.6066 25.7593 22.0544 25.3178L19.8041 23.5948ZM43 12.2595V34.6353L29.7931 22.3718L43 12.2595ZM41.3551 11H6.6449L23.2795 23.7369C23.2862 23.742 23.2929 23.7473 23.2995 23.7526C23.4979 23.9127 23.7451 24 24 24C24.2549 24 24.5021 23.9127 24.7005 23.7526L24.7107 23.7445L24.7205 23.7369L41.3551 11ZM6 9C4.27942 9 3 10.2794 3 12V34.9531C3 36.6427 4.24894 38 6 38H42C43.7206 38 45 36.7206 45 35V12C45 10.2794 43.7206 9 42 9H6Z"
  }));
};
export default EmailHifiIcon;